import { render, staticRenderFns } from "./TodoFooter.vue?vue&type=template&id=5c4e124d&scoped=true&"
import script from "./TodoFooter.vue?vue&type=script&lang=js&"
export * from "./TodoFooter.vue?vue&type=script&lang=js&"
import style0 from "./TodoFooter.vue?vue&type=style&index=0&id=5c4e124d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e124d",
  null
  
)

export default component.exports